import { useCallback } from 'react';

class AuthenticationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthenticationError';
  }
}

// TODO: rename to something else because it is no longer authenticated
// TODO: probably no need to have it in a hook. It can be a shared util function. To be done in another PR, too many files would change now.
export const useAuthenticatedFetch = () => {
  const authenticatedFetch = useCallback(async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    const headers = new Headers(init?.headers || {});
    headers.set('Content-Type', 'application/json');

    const response = await fetch(input, {
      ...init,
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new AuthenticationError('Authentication failed');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  }, []);

  return authenticatedFetch;
};
